import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";

const POPULAR_CITIES = [
  { slug: "prosper", name: "Prosper" },
  { slug: "frisco", name: "Frisco" },
  { slug: "mckinney", name: "McKinney" },
];

const POPULAR_SERVICES = [
  { slug: "garage-door-spring-repair", name: "Spring Repair" },
  { slug: "garage-door-opener-repair", name: "Opener Repair" },
  { slug: "new-garage-door-installation", name: "New Door Installation" },
];

export default function PopularServices() {
  return (
    <section className="bg-slate-900 text-white py-20 lg:py-28" data-testid="popular-services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-red-500">Most Requested</p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight">
            Popular Garage Door Services Near You
          </h2>
          <p className="mt-4 text-lg text-slate-300">
            Fast, same-day service in our busiest Collin County cities — jump straight to the help you need.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {POPULAR_CITIES.map((c) => (
            <div
              key={c.slug}
              className="bg-white/5 border border-white/10 rounded-sm p-6 hover:border-red-600/60 transition-colors"
              data-testid={`popular-city-${c.slug}`}
            >
              <Link
                to={`/garage-door-repair/${c.slug}`}
                className="inline-flex items-center gap-2 font-heading text-xl font-bold text-white hover:text-red-500 transition-colors"
              >
                <MapPin className="h-5 w-5 text-red-600" /> {c.name}, TX
              </Link>
              <div className="mt-4 flex flex-col divide-y divide-white/10">
                {POPULAR_SERVICES.map((s) => (
                  <Link
                    key={s.slug}
                    to={`/${s.slug}/${c.slug}`}
                    className="group flex items-center justify-between py-3 text-slate-200 hover:text-red-400 transition-colors"
                    data-testid={`popular-link-${s.slug}-${c.slug}`}
                  >
                    <span className="font-semibold">{s.name}</span>
                    <ArrowRight className="h-4 w-4 text-red-600 group-hover:translate-x-1 transition-transform" />
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
